class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    // this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  // toggleResetButton() {
  //   const resetIsHidden = this.resetButton.classList.contains("hidden");
  //   if (this.input.value.length > 0 && resetIsHidden) {
  //     this.resetButton.classList.remove("hidden");
  //   } else if (this.input.value.length === 0 && !resetIsHidden) {
  //     this.resetButton.classList.add("hidden");
  //   }
  // }

  onChange() {
    // this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      // this.toggleResetButton();
    }
  }
}

function waitForConditions(callback, ...conditions) {
  const promises = conditions.map(
    (condition) =>
      new Promise((resolve) => {
        let interval = setInterval(() => {
          if (condition()) {
            clearInterval(interval);
            resolve(true);
          }
        }, 100);
      })
  );

  Promise.all(promises).then(() => {
    callback();
  });
}

waitForConditions(
  () => {
    const BREAKPOINT_TABLET = 989;
    var cuSearchBarDiv = document.createElement("div");
    cuSearchBarDiv.setAttribute("class", "cu-searchBar-with-typingText-wrapper");
    var cuSearchBarHtml = `<button type="button" aria-controls="header-search-modal" class="cu-searchBar-with-typingText-text-area">
            <p class="typingTextData" aria-label="What are you looking for?">I am looking for <span aria-hidden="true"></span><span id="cursor" aria-hidden="true">|</span></p>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <title>Search</title>
              <path d="M8.71464 15.5148C12.1743 15.5148 14.9788 12.7102 14.9788 9.25056C14.9788 5.79094 12.1743 2.98636 8.71464 2.98636C5.25502 2.98636 2.45044 5.79094 2.45044 9.25056C2.45044 12.7102 5.25502 15.5148 8.71464 15.5148Z" stroke="#303030" stroke-width="0.954545" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.1438 13.6802L16.7682 17.3045" stroke="#303030" stroke-width="0.954545" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>`;
    cuSearchBarDiv.innerHTML = cuSearchBarHtml;

    const desktopPosition = document.querySelector(".header__icons details-modal.header__search"),
          mobilePosition = document.querySelector(".search-bar-placeholder");
    if (window.innerWidth > BREAKPOINT_TABLET) {
      desktopPosition.prepend(cuSearchBarDiv);
    } else {
      mobilePosition.append(cuSearchBarDiv);
    }

    const typeStringData = ["Pumping Bra", "Nursing Bra", "Shorts", "Robe", "Joggers"];
    const element = document.querySelector(".typingTextData span");
    const cursor = document.getElementById("cursor");
    let currentIndex = 0;

    function typeString(index) {
      const text = typeStringData[index];
      let charIndex = 0;
      const typeInterval = setInterval(() => {
        if (charIndex < text.length) {
          element.textContent += text.charAt(charIndex);
          charIndex++;
        } else {
          clearInterval(typeInterval);
          setTimeout(() => {
            element.textContent = ""; // Clear the text
            currentIndex = (currentIndex + 1) % typeStringData.length; // Move to the next string
            typeString(currentIndex);
          }, 2000); // Wait for 2 seconds before typing the next string
        }
      }, 150); // Typing speed (adjust as needed)
    }

    setInterval(() => {
      cursor.style.visibility = cursor.style.visibility === "visible" ? "hidden" : "visible"; // Toggle cursor visibility
    }, 500); // Blinking cursor speed (adjust as needed)

    typeString(currentIndex);

    document.querySelector(".cu-searchBar-with-typingText-text-area").addEventListener("click", () => {
      setTimeout(() => {
        document
          .querySelector(
            "summary.header__icon.header__icon--search.header__icon--summary.link.focus-inset.modal__toggle"
          )
          .click();
      }, 100);
    });   

    // adjust position if window is resized and breakpoint is hit
    const searchBarEl = document.querySelector('.cu-searchBar-with-typingText-wrapper');
    window.addEventListener('resize', () => {
      if (window.innerWidth > BREAKPOINT_TABLET) {
        desktopPosition.prepend(searchBarEl);
      } else {
        mobilePosition.append(searchBarEl);
      }
    });
  },
  () => document.querySelectorAll(".header__icons details-modal.header__search").length > 0,
  () => document.querySelectorAll("sticky-header.header-wrapper").length > 0
);

customElements.define("search-form", SearchForm);
